export const ERROR_CODES = { WORK_LOG_CONFLICT_CODE: '143' } as const